// 9fbef606107a605d69c0edbcd8029e5d

export const PDP_SUB_LABELS = 'ProductDetailPage.PDP_Sub';

export const pdpSubLabels = {
  ProductDetailPage: {
    PDP_Sub: {
      lbl_you_may_also_like: 'You May Also Like',
      lbl_recently_viewed: 'People Also Purchased',
      lbl_multipack_single_text: 'Single',
      lbl_write_review: 'Write A Review',
      lbl_in_bag: 'IN BAG',
      lbl_key_features: 'KEY FEATURES',
      lbl_product_description_label: 'PRODUCT DESCRIPTION',
      lbl_product_include_text: 'Pack Includes',
      lbl_view_more: 'View more',
      lbl_view_less: 'View less',
      lbl_product_description_show_more: 'Show More',
      lbl_product_description_show_less: 'Show Less',
      lbl_product_description_item_part_number: 'Item #:',
      lbl_about_this_collection: 'About this collection',
      lbl_back_to_results: 'Back To Results',
      lbl_look_x_of_y: 'Look {x} of {y}',
      lbl_items_in_this_look: 'Items in this look',
      lbl_complete_the_look: 'Complete The Look',
      lbl_product_description_claim_message: 'Big Fashion, Little Prices',
      lbl_be_first_to_review: 'Be the first to review! ',
      lbl_select_nearby_check: 'Not available in your store. Select a size to check nearby.',
      lbl_last_purchased: 'Last Purchased',
      lbl_store_special_pickup_today: 'Pickup Today',
      lbl_store_special_txt: 'Pickup in store special',
      lbl_ss_bopis_promotion: 'Pickup today for just',
      lbl_ss_sth_promotion: 'Ship to home or store from',
    },
  },
};
